import { createSlice } from "@reduxjs/toolkit";
import { getUniversityDetail } from "./universityApi";
import { University } from "@/store/types/universityTypes";

interface UniversityState {
  universityDetail: University | null; // Use `null` to indicate the absence of data initially
  loading: boolean;
  activeTab: number;
}

const initialState: UniversityState = {
  universityDetail: null, // Now properly typed
  loading: false,
  activeTab: 4,
};

const universitySlice = createSlice({
  name: "university",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getUniversityDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUniversityDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.universityDetail = action.payload;
      })
      .addCase(getUniversityDetail.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setActiveTab } = universitySlice.actions;
export default universitySlice.reducer;
